import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-3 col-xl-4 col-lg-4" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_5 = { class: "card upload-gallery border-0 rounded-1 p-xxl-30 p-4" }
const _hoisted_6 = { class: "file-upload text-center position-relative mb-35" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "d-block text-optional fs-14 mb-2" }
const _hoisted_9 = { class: "col-xxl-9 col-xl-8 col-lg-8" }
const _hoisted_10 = { class: "row gx-xxl-6" }
const _hoisted_11 = { class: "col-lg-6" }
const _hoisted_12 = { class: "form-group mb-25" }
const _hoisted_13 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "col-lg-6" }
const _hoisted_16 = { class: "form-group mb-25" }
const _hoisted_17 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = { class: "col-lg-6" }
const _hoisted_20 = { class: "form-group mb-25" }
const _hoisted_21 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_22 = ["placeholder"]
const _hoisted_23 = { class: "col-lg-6" }
const _hoisted_24 = { class: "form-group mb-25" }
const _hoisted_25 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = { class: "col-lg-6" }
const _hoisted_28 = { class: "form-group mb-25" }
const _hoisted_29 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_30 = ["placeholder"]
const _hoisted_31 = { class: "col-lg-6" }
const _hoisted_32 = { class: "form-group mb-25" }
const _hoisted_33 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_34 = ["placeholder"]
const _hoisted_35 = { class: "col-lg-12" }
const _hoisted_36 = { class: "form-group mb-25" }
const _hoisted_37 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_38 = ["placeholder"]
const _hoisted_39 = { class: "col-lg-6" }
const _hoisted_40 = { class: "form-group mb-25" }
const _hoisted_41 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_42 = ["placeholder"]
const _hoisted_43 = { class: "col-lg-6" }
const _hoisted_44 = { class: "form-group mb-25" }
const _hoisted_45 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_46 = ["placeholder"]
const _hoisted_47 = { class: "col-lg-6" }
const _hoisted_48 = { class: "form-group mb-25" }
const _hoisted_49 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_50 = ["placeholder"]
const _hoisted_51 = { class: "col-12" }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    class: "pb-60",
    autocomplete: "off",
    onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
  }, [
    _cache[13] || (_cache[13] = _createElementVNode("input", {
      type: "text",
      name: "fake_username",
      autocomplete: "username",
      class: "d-none",
      tabindex: "-1"
    }, null, -1)),
    _cache[14] || (_cache[14] = _createElementVNode("input", {
      type: "password",
      name: "fake_password",
      autocomplete: "new-password",
      class: "d-none",
      tabindex: "-1"
    }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.profile_image`)), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _ctx.previewAvatarUrl,
                alt: _ctx.$t(`${_ctx.i18nScope}.profile_image_alt`),
                class: "profile-preview mb-3"
              }, null, 8, _hoisted_7),
              _createElementVNode("input", {
                ref: "avatarInput",
                type: "file",
                class: "d-none",
                accept: "image/*",
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleAvatarChange && _ctx.handleAvatarChange(...args)))
              }, null, 544),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.profile_image_caption`)), 1),
              _createElementVNode("button", {
                type: "button",
                class: "btn style-two btn-sm",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openAvatarPicker && _ctx.openAvatarPicker(...args)))
              }, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.select_image`)), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.first_name`)), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.first_name) = $event)),
                type: "text",
                class: "w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title",
                placeholder: _ctx.$t(`${_ctx.i18nScope}.first_name`),
                required: ""
              }, null, 8, _hoisted_14), [
                [_vModelText, _ctx.form.first_name]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.last_name`)), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.last_name) = $event)),
                type: "text",
                class: "w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title",
                placeholder: _ctx.$t(`${_ctx.i18nScope}.last_name`)
              }, null, 8, _hoisted_18), [
                [_vModelText, _ctx.form.last_name]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.username`)), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.username) = $event)),
                type: "text",
                class: "w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title",
                placeholder: _ctx.$t(`${_ctx.i18nScope}.username`),
                required: ""
              }, null, 8, _hoisted_22), [
                [_vModelText, _ctx.form.username]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.phone_number`)), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.phone) = $event)),
                type: "text",
                class: "w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title",
                placeholder: _ctx.$t(`${_ctx.i18nScope}.phone_number`),
                required: ""
              }, null, 8, _hoisted_26), [
                [_vModelText, _ctx.form.phone]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.email`)), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.email) = $event)),
                type: "email",
                class: "w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title",
                placeholder: _ctx.$t(`${_ctx.i18nScope}.email`),
                required: ""
              }, null, 8, _hoisted_30), [
                [_vModelText, _ctx.form.email]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.company`)), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.company) = $event)),
                type: "text",
                class: "w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title",
                placeholder: _ctx.$t(`${_ctx.i18nScope}.company`)
              }, null, 8, _hoisted_34), [
                [_vModelText, _ctx.form.company]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.address`)), 1),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.address) = $event)),
                cols: "30",
                rows: "6",
                placeholder: _ctx.$t(`${_ctx.i18nScope}.address`),
                class: "d-block w-100 bg-white border-0 rounded-1 resize-none fs-14 text-title"
              }, null, 8, _hoisted_38), [
                [_vModelText, _ctx.form.address]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.current_password`)), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.passwordForm.current_password) = $event)),
                type: "password",
                name: "current_password",
                autocomplete: "new-password",
                class: "w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title",
                placeholder: _ctx.$t(`${_ctx.i18nScope}.current_password`)
              }, null, 8, _hoisted_42), [
                [_vModelText, _ctx.passwordForm.current_password]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.new_password`)), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.passwordForm.new_password) = $event)),
                type: "password",
                name: "new_password",
                autocomplete: "new-password",
                class: "w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title",
                placeholder: _ctx.$t(`${_ctx.i18nScope}.new_password`)
              }, null, 8, _hoisted_46), [
                [_vModelText, _ctx.passwordForm.new_password]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.confirm_new_password`)), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.passwordForm.new_password_confirmation) = $event)),
                type: "password",
                name: "new_password_confirmation",
                autocomplete: "new-password",
                class: "w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title",
                placeholder: _ctx.$t(`${_ctx.i18nScope}.confirm_new_password`)
              }, null, 8, _hoisted_50), [
                [_vModelText, _ctx.passwordForm.new_password_confirmation]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("button", {
              class: "btn style-one transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16",
              type: "submit",
              disabled: _ctx.isSubmitting
            }, [
              (_ctx.isSubmitting)
                ? (_openBlock(), _createElementBlock("span", _hoisted_53))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.isSubmitting ? _ctx.$t(`${_ctx.i18nScope}.updating_profile`) : _ctx.$t(`${_ctx.i18nScope}.update_profile`)), 1)
            ], 8, _hoisted_52)
          ])
        ])
      ])
    ])
  ], 32))
}